import React, { useState, useEffect } from "react";
import axios from "axios";
import "./githubproject.css";
import GitHubCalendar from "react-github-calendar";

import CountUp from "react-countup";
var randomColor = require("randomcolor"); // import the script

export default function GitHubProject() {
  const [githubProfilePicture, setGithubProfilePicture] = useState();
  const [gitUserName, setgitUserName] = useState();
  const [githubPublicRepos, setgithubPublicRepos] = useState(0);
  const [followers, setfollowers] = useState(0);
  const [following, setfollowing] = useState(0);
  const [htmlUrl, sethtmlUrl] = useState();
  const [bio, setbio] = useState();
  const [githubproject, setGithubProject] = useState([]);
  const [loading, setLoading] = useState(0);

  function ChangeColor() {
    var color = randomColor({ luminosity: "bright", format: "rgb" });
    return color;
  }

  useEffect(() => {
    axios
      .get("https://api.github.com/users/senuravihanjayadeva")
      .then(({ data }) => {
        console.log(data);
        setgitUserName(data.login);
        setgithubPublicRepos(data.public_repos);
        setGithubProfilePicture(data.avatar_url);
        setfollowers(data.followers);
        setfollowing(data.following);
        sethtmlUrl(data.html_url);
        setbio(data.bio);
      })
      .catch((err) => {
        alert(err);
      });

    axios
      .get("https://api.github.com/users/senuravihanjayadeva/repos")
      .then(({ data }) => {
        console.log(data);
        setGithubProject(data);
        if (data.length > 0) {
          setLoading(1);
        }
      })
      .catch((err) => {
        alert(err);
      });
  }, []);
  return (
    <div>
      {loading == 0 ? (
        <center>
          <div class="GitHubNoDataDiv">
            <div
              class="spinner-border text-primary"
              role="status"
              style={{ height: "80px", width: "80px" }}
            >
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        </center>
      ) : (
        <main class="page projets-page">
          <section class="portfolio-block project-no-images">
            <div class="container">
              <div class="heading">
                <div className="row">
                  <div className="col-md-6">
                    <img
                      src={githubProfilePicture}
                      style={{ borderRadius: "50%", width: "250px" }}
                    />
                  </div>

                  <div className="col-md-6">
                    <div className="container" style={{ marginTop: "5%" }}>
                      <h4>{gitUserName}</h4>
                      {/* <p>{bio}</p> */}
                      <p>
                        Following{" "}
                        <span className="countNumbers">
                          <CountUp
                            start={0}
                            end={following}
                            duration={4}
                            separator=","
                          />
                        </span>
                      </p>
                      <p>
                        Followers{" "}
                        <span className="countNumbers">
                          <CountUp
                            start={0}
                            end={followers}
                            duration={4}
                            separator=","
                          />
                        </span>
                      </p>

                      <p>
                        Repositories{" "}
                        <span className="countNumbers">
                          <CountUp
                            start={0}
                            end={githubPublicRepos}
                            duration={5}
                            separator=","
                          />
                        </span>
                      </p>
                      <hr />
                      <a href={htmlUrl} className="btn btn-outline-primary">
                        View GitHub Account
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div className="col-md-12 text-center">
                  <GitHubCalendar username="senuravihanjayadeva" />
                </div>
              </div>
              <div class="row">
                {githubproject.map((singlegitproject) => {
                  return (
                    <div class="col-md-6 col-lg-4">
                      <div
                        class="project-card-no-image"
                        style={{ borderTop: `4px solid ${ChangeColor()}` }}
                      >
                        <h3>{singlegitproject.name}</h3>
                        <h4>{singlegitproject.description}</h4>
                        <p>{singlegitproject.created_at.substring(0, 10)}</p>
                        <a
                          class="btn btn-outline-primary btn-sm"
                          role="button"
                          target="_blank"
                          href={singlegitproject.clone_url}
                        >
                          See More
                        </a>
                        <div class="tags">
                          <a href="#">{singlegitproject.language}</a>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </section>
        </main>
      )}
    </div>
  );
}
